import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

/*
 * Banniere de reprise du diagnostic (session active uniquement).
 */
export const ResumeBanner = ({ answeredCount, onResume, onRestart }) => (
  <div className="min-h-screen flex items-center justify-center px-4 gbs-hero-wash">
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      className="w-full max-w-[440px] rounded-2xl bg-white border border-[rgba(35,82,119,0.14)] p-6 sm:p-8 shadow-[var(--shadow-md)]"
      data-testid="diagnostic-resume-banner"
    >
      <h1 className="font-heading text-xl font-semibold text-[#060606]">Reprendre où tu t’es arrêtée ?</h1>
      <p className="mt-2 text-sm leading-relaxed text-[#333333]">
        Tu as déjà répondu à {answeredCount} question{answeredCount > 1 ? "s" : ""}. Tes réponses sont
        conservées uniquement dans cette session de navigation.
      </p>
      <div className="mt-6 flex flex-col gap-3">
        <Button
          data-testid="diagnostic-resume-button"
          onClick={onResume}
          className="min-h-[48px] rounded-xl bg-[#235277] hover:bg-[#1E4767] font-heading font-semibold transition-colors duration-200"
        >
          Reprendre mon diagnostic
        </Button>
        <Button
          data-testid="diagnostic-restart-button"
          onClick={onRestart}
          variant="outline"
          className="min-h-[48px] rounded-xl border-[rgba(35,82,119,0.22)] text-[#235277] hover:bg-[#E2F6FF] font-heading font-semibold transition-colors duration-200"
        >
          Recommencer à zéro
        </Button>
      </div>
    </motion.div>
  </div>
);
